<template>
    <paper class="appointment">
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="电商预约" name="ECommerce">
                <ECommerce/>
            </el-tab-pane>
            <el-tab-pane label="运输单查询" name="Transport">
                <Transport/>
            </el-tab-pane>
            <!-- <el-tab-pane label="天猫入园预约记录" name="Tmall">
                <Tmall/>
            </el-tab-pane> -->
        </el-tabs>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import ECommerce from './ecommerce/Index';
import Transport from './transport/Index';
// import Tmall from './tmall/Index';
export default {
    name: 'appointment',
    // components: { paper, ECommerce, Transport, Tmall },
    components: { paper, ECommerce, Transport },
    data() {
        return {
            activeName: 'ECommerce'
        };
    },
    methods: {
        tabClick(val) {
            const btnVal = {
                ECommerce: '订单管理-大物流,预约任务,电商预约,电商预约-查询',
                Transport: '订单管理-大物流,预约任务,运输单查询,运输单查询-查询'
            };
            window.bigDataConfig = { 'bigData-btn-search': btnVal[val.name] };
        }
    },
    activated () {
        this.tabClick({ name: this.activeName });
    }
};
</script>
<style lang="less">
.appointment{
    .tablePage{
        .el-table {
            min-height: calc(~ '100vh - 223px') !important;
            max-height: calc(~ '100vh - 223px') !important;
        }
    }
}
</style>